import { Component } from '@angular/core';
import { NgZorroAntdModule } from '../../../ng-zorro-antd.module';
import { SettingsService } from '@core/services/settings/settings.service';
import { HostListener } from '@angular/core';
import { GlobalI18n } from '@settings/global-i18n';
import { Module } from '@shared/models/module-name';

enum Season {
	WINTER,
	SPRING,
	SUMMER,
	AUTUMN,
}

@Component({
	selector: 'mfp-home',
	standalone: true,
	imports: [NgZorroAntdModule],
	templateUrl: './home.component.html',
	styleUrl: './home.component.less',
})
export class HomeComponent {
	screenHeight: number;
	screenWidth: number;

	@HostListener('window:resize')
	getScreenSize() {
		this.screenWidth = window.innerWidth;
	}

	constructor(private settingsService: SettingsService, private globalI18n: GlobalI18n) {
		this.getScreenSize();
	}

	get userFullName() {
		const firstName =
			this.settingsService.user.getFirstName() !== undefined ? this.settingsService.user.getFirstName() : '';
		const lastName =
			this.settingsService.user.getLastName() !== undefined ? this.settingsService.user.getLastName() : '';
		if (firstName === '' && lastName === '') {
			return this.globalI18n.getMessage(Module.General, 'userUnknown');
		} else {
			return firstName + ' ' + lastName;
		}
	}

	get userLogin() {
		return this.settingsService.user.getLogin();
	}

	get userDefaultAvatarImageUrl() {
		const month = new Date().getMonth() + 1;
		switch (this.getSeason(month)) {
			case Season.WINTER:
				return 'assets/img/general/season_winter.svg';
			case Season.SPRING:
				return 'assets/img/general/season_spring.svg';
			case Season.SUMMER:
				return 'assets/img/general/season_summer.svg';
			case Season.AUTUMN:
				return 'assets/img/general/season_autumn.svg';
		}
	}

	getSeason(mountNumber: number) {
		const seasons = [Season.WINTER, Season.SPRING, Season.SUMMER, Season.AUTUMN];
		return seasons[Math.floor((mountNumber / 12) * 4) % 4];
	}

	get userAvatarSize() {
		return this.screenWidth / 14;
	}
}
